import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MenuAksiLogin: React.FC = () => {
    const navigate = useNavigate();
    
    // Cek localStorage langsung saat inisialisasi state agar tidak berkedip
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        return !!localStorage.getItem('user');
    });

    useEffect(() => {
        const checkLoginStatus = () => {
            const userStored = localStorage.getItem('user');
            setIsLoggedIn(!!userStored);
        };

        window.addEventListener("storage", checkLoginStatus);
        window.addEventListener("login-change", checkLoginStatus); 

        return () => {
            window.removeEventListener("storage", checkLoginStatus);
            window.removeEventListener("login-change", checkLoginStatus);
        };
    }, []);

    // Jika user sudah login, sembunyikan CTA banner
    if (isLoggedIn) {
        return null;
    }

    const handleActionClick = () => {
        navigate('/auth/login'); 
    };

    return (
        <section className="w-full bg-[#FEE6E6] relative overflow-hidden">
            {/* Solid Red Fill: Menutup penuh sisi kanan layar hingga ujung (anti-bocor saat zoom out / layar ultrawide) */}
            <div 
                className="pointer-events-none select-none absolute top-0 bottom-0 right-0 bg-[#C60302] z-0 hidden lg:block"
                style={{ left: 'calc(50% + 660px)' }}
                aria-hidden="true"
            />

            <div className="max-w-[1440px] mx-auto min-h-[484px] lg:h-[484px] relative flex flex-col lg:flex-row items-center justify-between">
                
                {/* Rectangle 29: Aksen Geometris Merah Miring (Desktop) */}
                <div 
                    className="pointer-events-none select-none absolute w-[1128px] h-[760px] bg-[#C60302] rounded-[100px] -rotate-[24.46deg] origin-center z-0 hidden lg:block"
                    style={{ left: '625px', top: '116px' }}
                    aria-hidden="true"
                />

                {/* Rectangle 29: Aksen Geometris Merah Miring (Mobile & Tablet) */}
                <div 
                    className="pointer-events-none select-none absolute -bottom-[100px] -right-[80px] w-[460px] h-[380px] sm:w-[600px] sm:h-[460px] bg-[#C60302] rounded-[60px] -rotate-[20deg] z-0 lg:hidden"
                    aria-hidden="true"
                />

                {/* Content Left: Headline, Subtitle, & CTA Button */}
                <div className="relative z-10 w-full lg:w-auto lg:max-w-[624px] px-6 sm:px-12 lg:pl-[100px] lg:pr-0 py-12 lg:py-0 flex flex-col items-start gap-6">
                    {/* Headline */}
                    <h2 className="font-montserrat font-bold text-[32px] sm:text-[38px] lg:text-[40px] leading-[1.2] text-[#202020] tracking-tight">
                        Ready to Start Learning <br />
                        <span className="text-[#C60302]">Indonesian?</span>
                    </h2>
                    
                    {/* Subtitle */}
                    <p className="font-montserrat font-normal text-[16px] sm:text-[18px] lg:text-[20px] leading-[1.4] text-[#6A6A6A] max-w-[503px]">
                        Join Flunesia today and experience structured Indonesian language learning designed for international learners.
                    </p>

                    {/* CTA Button */}
                    <button 
                        id="cta-start-learning-btn"
                        onClick={handleActionClick}
                        className="group inline-flex items-center justify-center gap-2 h-[48px] px-6 bg-[#C60302] hover:bg-[#A80201] text-white font-montserrat font-semibold text-[14px] leading-[17px] rounded-[8px] shadow-[2px_2px_4px_rgba(32,32,32,0.25)] hover:shadow-[0_6px_16px_rgba(198,3,2,0.35)] transition-all duration-200 active:scale-[0.98] cursor-pointer"
                    >
                        <span>Start Speaking Indonesian</span>
                        {/* basil:arrow-right-solid */}
                        <svg 
                            className="w-5 h-5 text-white flex-shrink-0 transition-transform duration-200 group-hover:translate-x-1" 
                            viewBox="0 0 24 24" 
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path 
                                fillRule="evenodd" 
                                d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z" 
                                clipRule="evenodd" 
                            />
                        </svg>
                    </button>
                </div>

                {/* Content Right: Mahasiswa Tertawa (org-laugh.png) */}
                <div className="relative z-10 w-full lg:w-auto flex justify-center lg:justify-start mt-4 lg:mt-0 lg:absolute lg:left-[641px] lg:bottom-0 pointer-events-none select-none">
                    <img 
                        src="/org-laugh.png" 
                        alt="Fluenesia Indonesian Language Students" 
                        className="w-auto h-[320px] sm:h-[400px] lg:h-[484px] max-w-full object-contain object-bottom"
                        loading="lazy"
                    />
                </div>

            </div>
        </section>
    );
};

export default MenuAksiLogin;